<template>
  <div class="cont">
    <div class="title" :style="{ backgroundImage: 'url(' + curData.title + ')'}" :class="title_object">
      <div class="title_name" :style="{ backgroundImage: 'url(' + curData.title_text + ')'}" :class="title_name_object"></div>
    </div>

    <div class="clear" v-if=" id == 'twoPiece'  ">
      <div style="width: 223px  ;float:left" >
        <el-image 
          style="width: 223px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 500px  ;float:right ; text-align:right" >
        <el-image 
          style="width: 337px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 272px ; height : 230px ;float:left ; margin-top :31px" >
        <el-image 
          style="width: 272px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 268px  ;float:right ; text-align:right ; margin-top:14px" >
        <el-image 
          style="width: 268px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:60px" >
        <el-image 
          style="width: 95px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 709px  ;float:right ;  margin-top:0px" >
        <el-image 
          style="width: 709px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 709px  ;float:left ;  margin-top:46px" >
        <el-image 
          style="width: 422px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 709px  ;float:left ;  margin-top:39px" >
        <el-image 
          style="width: 259px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 709px  ;float:left ;  margin-top:18px" >
        <el-image 
          style="width: 392px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 765px  ;float:left ;  margin-top:39px" >
        <el-image 
          style="width: 765px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 775px  ;float:left ;  margin-top:39px" >
        <el-image 
          style="width: 775px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 768px  ;float:left ;  margin-top:39px" >
        <el-image 
          style="width: 768px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>

    </div>
    <div class="clear" v-else-if=" id == 'FP_FS'  ">
      <div style="width: 350px  ;float:left" >
        <el-image 
          style="width: 350px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 334px  ;float:right ; text-align:right" >
        <el-image 
          style="width: 334px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 389px ; height : 389px ;float:left ; margin-top :31px" >
        <el-image 
          style="width: 389px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style="width: 100%;text-align:center  ;float:left ;  margin-top:66px" >
        <el-image 
          style="width: 775px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;text-align:center  ;float:left ;  margin-top:43px" >
        <el-image 
          style="width: 777px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;text-align:center  ;float:left ;  margin-top:58px" >
        <el-image 
          style="width: 774px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;text-align:center  ;float:left ;  margin-top:50px" >
        <el-image 
          style="width: 772px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;text-align:center ;float:left ;  margin-top:73px" >
        <el-image 
          style="width: 773px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>


    </div>
    <div class="clear" v-else-if=" id == 'HS' || id == 'HD' ">
      <div style="width: 296px  ;float:left" >
        <el-image 
          style="width: 296px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 334px  ;float:right ; text-align:right;position:relative" >
        <el-image 
          style="width: 334px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image 
          style="width: 300px ;bottom:15px;left:17px;position:absolute"
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 259px ; height : 113px ;float:left ; margin-top :15px;" >
        <el-image 
          style="width: 259px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:right ; text-align:right ; margin-top:14px" >
        <el-image 
          style="width: 268px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:60px" >
        <el-image 
          style="width: 95px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%;text-align:center  ;float:left ;" >
        <el-image 
          style="width: 686px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; ;float:left ;margin-top:46px" >
        <el-image 
          style="width: 422px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; ;float:left ;margin-top:39px" >
        <el-image 
          style="width: 259px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
     <div style="width: 100%; ;float:left ;margin-top:19px" >
        <el-image 
          style="width: 629px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; ;float:left ;margin-top:33px" >
        <el-image 
          style="width: 632px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; ;float:left ;margin-top:48px" >
        <el-image 
          style="width: 776px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; ;float:left ;margin-top:21px" >
        <el-image 
          style="width: 777px ; "
          v-show="curData.src13 "
          :src=" curData.src13  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear" v-else-if=" id == 'PD'  ">
      <div style="width: 272px  ;float:left" >
        <el-image 
          style="width: 272px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 334px  ;float:right ; text-align:right ; position:relative;" >
        <el-image 
          style="width: 334px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
        <el-image 
          style="width: 91px ; position:absolute;top:-50px;right:7px"
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>

      </div>
      <div style="width: 411px  ;float:left; margin-top:46px" >
        <el-image 
          style="width: 411px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%; text-align:right  ;float:right; margin-top:14px" >
        <el-image 
          style="width: 268px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:60px" >
        <el-image 
          style="width: 95px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:0px ; text-align:center" >
        <el-image 
          style="width: 658px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style="width: 100%  ;float:left ;  margin-top:43px ; " >
        <el-image 
          style="width: 422px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:39px ; " >
        <el-image 
          style="width: 179px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 126px  ;float:left ;  margin-top:18px ; margin-right:22px " >
        <el-image 
          style="width: 126px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 493px  ;float:left ;  margin-top:18px ;" >
        <el-image 
          style="width: 493px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>

      <div style="width: 100%  ;float:left ;  margin-top:43px ; " >
        <el-image 
          style="width: 777px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>

    </div>
    <div class="clear" v-else-if=" id == 'SD'  ">
      <div style="width: 236px  ;float:left" >
        <el-image 
          style="width: 236px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 330px  ;float:right ; text-align:right" >
        <el-image 
          style="width: 330px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 412px  ;float:left;margin-top:32px" >
        <el-image 
          style="width: 412px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:60px" >
        <el-image 
          style="width: 95px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:0px ; text-align:center" >
        <el-image 
          style="width: 658px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:43px ; " >
        <el-image 
          style="width: 415px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:39px ; " >
        <el-image 
          style="width: 179px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 263px  ;float:left ;  margin-top:19px ;margin-right:38px " >
        <el-image 
          style="width: 263px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 472px  ;float:left ;  margin-top:19px ;" >
        <el-image 
          style="width: 472px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:44px ;" >
        <el-image 
          style="width: 367px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:21px ;" >
        <el-image 
          style="width: 656px ; "
          v-show="curData.src11 "
          :src=" curData.src11  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:48px ;" >
        <el-image 
          style="width: 295px ; "
          v-show="curData.src12 "
          :src=" curData.src12  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:15px ;" >
        <el-image 
          style="width: 765px ; "
          v-show="curData.src13 "
          :src=" curData.src13  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:42px ;" >
        <el-image 
          style="width: 765px ; "
          v-show="curData.src14 "
          :src=" curData.src14  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:42px ;" >
        <el-image 
          style="width: 765px ; "
          v-show="curData.src15 "
          :src=" curData.src15  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
    <div class="clear" v-else-if=" id == 'FC'  ">
      <div style="width: 311px  ;float:left" >
        <el-image 
          style="width: 311px ; "
          v-show="curData.src1 "
          :src=" curData.src1  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 334px  ;float:right" >
        <el-image 
          style="width: 334px ; "
          v-show="curData.src2 "
          :src=" curData.src2  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 353px  ;float:left;margin-top:16px" >
        <el-image 
          style="width: 353px ; "
          v-show="curData.src3 "
          :src=" curData.src3  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 800px  ;float:left ;  margin-top:60px" >
        <el-image 
          style="width: 95px ; "
          v-show="curData.src4 "
          :src=" curData.src4  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:0px ; text-align:center" >
        <el-image 
          style="width: 661px ; "
          v-show="curData.src5 "
          :src=" curData.src5  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:0px ;" >
        <el-image 
          style="width: 422px ; "
          v-show="curData.src6 "
          :src=" curData.src6  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:39px ;" >
        <el-image 
          style="width: 259px ; "
          v-show="curData.src7 "
          :src=" curData.src7  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:20px ;" >
        <el-image 
          style="width: 390px ; "
          v-show="curData.src8 "
          :src=" curData.src8  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:22px ;" >
        <el-image 
          style="width: 493px ; "
          v-show="curData.src9 "
          :src=" curData.src9  "
          fit="contain"
        >
        </el-image>
      </div>
      <div style="width: 100%  ;float:left ;  margin-top:27px ;" >
        <el-image 
          style="width: 777px ; "
          v-show="curData.src10 "
          :src=" curData.src10  "
          fit="contain"
        >
        </el-image>
      </div>
    </div>
  </div>

  
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      id : '' ,
      pageData : {
        FP_FS : {
          name : 'FP_FS' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img3.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img9.png') ,
        },
        HD : {
          name : 'HD' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img9.png') ,
          src10 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img10.png') ,
          src11 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img11.png') ,
          src12 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img12.png') ,
          src13 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img13.png') ,
        } ,
        HS : {
          name : 'HS' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img9.png') ,
          src10 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img10.png') ,
          src11 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img11.png') ,
          src12 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img12.png') ,
          src13 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img13.png') ,

        } ,
        SD : {
          name : 'SD' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/SD/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/SD/title_text.png') ,          
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img15.png') ,
        } ,
        twoPiece : {
          name : 'twoPiece' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/title_text.png') ,
          src1 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img1.png') ,
          src2 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img2.png') ,
          src3 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img3.png') ,
          src4 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img4.png') ,
          src5 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img5.png') ,
          src6 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img6.png') ,
          src7 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img7.png') ,
          src8 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img8.png') ,
          src9 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img9.png') ,
          src10 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img10.png') ,
          src11 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img11.png') ,
          src12 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img12.png') ,
        } ,
        PD : {
          name : 'PD' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/PD/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/PD/title_text.png') ,
          src1 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img1.png') ,
          src2 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img2.png') ,
          src3 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img3.png') ,
          src4 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img4.png') ,
          src5 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img5.png') ,
          src6 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img6.png') ,
          src7 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img7.png') ,
          src8 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img8.png') ,
          src9 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img9.png') ,
          src10 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img10.png') ,
          src11 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img11.png') ,
          src12 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img12.png') ,
        } ,
        FC : {
          name : 'FC' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/FC/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/FC/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img10.png') ,

        },

      },
      curData : {}
    }
  },
  methods: {
    getData () {
      let id = this.id
      this.curData = this.pageData[ id ]
    }
  } ,
  created(){
    this.id =  this.$route.params.id  
    this.getData()
  },
  computed: {
    title_object: function () {
      return { 
        "t_FP_FS" : this.curData.name == 'FP_FS' ,
        "t_HD_HS" : this.curData.name == 'HD' || this.curData.name == 'HS',
        "t_SD" : this.curData.name == 'SD' ,
        't_twoPiece' : this.curData.name == 'twoPiece' ,
        't_PD' : this.curData.name == 'PD' ,
        't_FC' : this.curData.name == 'FC'

      }
    },
    title_name_object : function () {
      return {
        't_n_FP_FS' : this.curData.name == 'FP_FS' ,
        't_n_HD_HS' : this.curData.name == 'HD'  || this.curData.name == 'HS' ,
        't_n_SD' : this.curData.name == 'SD' ,
        't_n_twoPiece' : this.curData.name == 'twoPiece' ,
        't_n_PD' : this.curData.name == 'PD' ,
        't_n_FC' : this.curData.name == 'FC'

      }
    },
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id 
      this.getData()

      // console.log( from )
    }
  }
}
</script>

<style lang="stylus" scoped>
.cont {
  width: 1003px;
  background-color: #fff;
  margin: 0 auto;
  padding: 62px 73px;
  box-sizing: border-box;
  position relative
}

.clear:after { 
  display: block;
  clear: both;
  content: '';
}

.title { 
  position: absolute;
  width: 170px;
  height: 108px;
  left: 66px;
  top: -68px;
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  font-size:30px 
  color:#fff;
  text-align :center
}
.t_FP_FS{
  padding: 28px 41px 16px 49px; 
  width: 170px;
  height: 108px;
}
.t_HD_HS{
  padding: 26px 29px 18px 42px; 
  width: 170px;
  height: 108px;
}
.t_SD {
    padding: 40px 46px; 
  width: 170px;
  height: 108px;
}
.t_twoPiece{
  padding: 30px 38px 30px 29px; 
  width: 170px;
  height: 108px;
}
.t_PD{
  padding: 40px 45px 40px 47px; 
  width: 170px;
  height: 108px;
}
.t_FC {
  padding: 40px 45px 40px 47px; 
  width: 170px;
  height: 108px;
}


.title_name {
  background-repeat: no-repeat;
  background-size: contain; 
}
.t_n_FP_FS{
  width: 80px;
  height: 64px;
}
.t_n_HD_HS{
  width: 99px;
  height: 64px;
}
.t_n_SD{
  width: 78px;
  height: 28px;
}
.t_n_twoPiece {
  width: 103px;
  height: 48px;
}
.t_n_PD{
  width: 78px;
  height: 28px;
}
.t_n_FC{
  width: 78px;
  height: 28px;
}

.text1{
  width : 296px ;
  font-size : 24px ;
  float: left;
  margin-bottom :27px
}
.text2{
  width: 411px;
  font-size :16px
  float: left;
}
.text3{
  width: 100%;
  font-size :16px;
  float: left;
  color #f90000;
  margin-top:40px
}
.text6{
  width: 596px;
  height: 554px;
  float: left;
  margin-top:52px;
  text-align center
}
.text7{
  width:100% ;
  float: left;
  margin-top:40px;

}
</style>